import { AnswererInfo, AnswerItem, IndicatorOperator, IndicatorType, QuestionTypes } from 'interface';

export const createQuestionTitle = (
    questionTitle: string,
    answerList: AnswerItem[] = [],
    answererContext?: AnswererInfo[],
    indicators?: IndicatorType[],
) => {
    const regex = /@\[[^@\[]+?()\]\([^@\[]+?()\)/g;
    // const matches = question.title.matchAll(/@\[.*?()\]\(\d+\)/g);
    let item;
    let title = questionTitle;
    while ((item = regex.exec(questionTitle))) {
        // const idRegex = /(?:@\[.*\]\()(\d+)(?=\))/.exec(item.value[0]);
        const idRegex = /\(([^\)]+-+\d+)\)/.exec(item[0]);
        let index;
        let indicator: number | undefined;
        let context: AnswererInfo | undefined = undefined;
        if (idRegex) {
            if (idRegex[1].startsWith('excel-') && answererContext) {
                const textRegex = /[^@\[]+?(?=\]\([^@\[]+\))/;
                const qTitle = textRegex.exec(item[0]);
                if (idRegex[1].length > 1)
                    context = answererContext.find((i) => i.column === Number(idRegex[1].replace('excel-', '')));
                else if (qTitle) context = answererContext.find((i) => i.value === qTitle[0]);
            } else if (idRegex[1].startsWith('quiz-') && answerList)
                index = answerList?.findIndex((i) => i.question.id === Number(idRegex[1].replace('quiz-', '')));
            else if (idRegex[1].startsWith('indicator-')) {
                const indicatorItem = indicators?.find((i) => i.id === Number(idRegex[1].replace('indicator-', '')));
                indicator = calcIndicator(indicatorItem, answerList);
            }
            if (index !== undefined && index > -1 && answerList) {
                const value = answerList[index].value;
                const items = answerList[index].question_items;
                if (value !== undefined && value !== null) {
                    title = title.replace(item[0], value);
                } else if (items) {
                    title = title.replace(item[0], items.map((i) => i.title).toString());
                }
            } else if (idRegex[1].startsWith('excel-') && context) {
                title = title.replace(item[0], context?.value);
            } else if (idRegex[1].startsWith('indicator-') && indicator !== undefined) {
                title = title.replace(item[0], indicator.toString());
            }
            // item = matches.next();
        }
    }
    return title;
};

export const calcIndicator = (indicator?: IndicatorType, answerList: AnswerItem[] = []) => {
    if (!indicator) return 0;
    let score = 0;
    indicator.questions.map((q) => {
        const indexQue = answerList.findIndex((i) => i.question.id === q.question);
        q.items.map((item) => {
            if (indexQue !== undefined && indexQue > -1) {
                if (
                    ([
                        QuestionTypes.dropDown,
                        QuestionTypes.selective,
                        QuestionTypes.pictureSelective,
                        QuestionTypes.twoOptions,
                        QuestionTypes.emoji,
                        QuestionTypes.matrix,
                    ].includes(answerList[indexQue].question.input_type) &&
                        item.item?.id &&
                        answerList[indexQue].question_items?.map((i) => i.id).includes(item.item?.id)) ||
                    ([QuestionTypes.nps, QuestionTypes.rate, QuestionTypes.scale].includes(
                        answerList[indexQue].question.input_type,
                    ) &&
                        answerList[indexQue].value === item.question_value)
                ) {
                    if (item.indicator_operator === IndicatorOperator.add) {
                        score = score + item.indicator_value;
                    } else if (item.indicator_operator === IndicatorOperator.divide) {
                        score = score / (item.indicator_value ?? 1);
                    } else if (item.indicator_operator === IndicatorOperator.multiply) {
                        score = score * item.indicator_value;
                    } else if (item.indicator_operator === IndicatorOperator.subtract) {
                        score = score - item.indicator_value;
                    }
                }
            }
        });
    });
    return score;
};
